export const routes: { [key: string]: string | boolean }[] = [
  { title: 'labs', route: 'labs', disabled: false },
  { title: 'launch', route: 'launch', disabled: false },
  { title: 'drops', route: 'drops', disabled: false },
  { title: 'vault', route: 'vault' },
]

export const LAST_BNB_RAISE_BEFORE_DATE = 1667606400000
export const OG_POOL_DATE = 1637798400000
